module.exports = __webpack_public_path__ + "img/13.85ebfa16.png";